import { Component } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';

import { BlockUiService } from './block-ui.service';

/**
 * Component wrapper for the primeNg block UI component.
 */
@Component({
	selector: 'cc-block-ui',
	templateUrl: './block-ui.component.html',
	styleUrls: ['./block-ui.component.css']
})
export class BlockUiComponent {

// #region [ Constructor ]

	constructor(
		private _BlockUiService: BlockUiService,
		private _Router: Router
	) {
		this._Router.events.subscribe(event => this.OnRoute(event));
	}

// #region [ Fields ]

	/** 
	 * The flag that reads from the block service. Bound to the HTML. 
	 */
	public get Blocked(): boolean {
		if (this._BlockUiService.DoNotShowBlockUi) {
			return false;
		}
		else {
			return this._BlockUiService.HttpRequestResponseCounter > 0 ? true : false;
		}
	}
	
// #region [ Private Methods ]

	/**
	 * Checks if a router event is RoutesRecognized and clears the block ui.
	 * 
	 * @param event The event fired by the navigation event.
	 */
	private OnRoute(event: object): void {
		if (event instanceof RoutesRecognized && (this.Blocked || this._BlockUiService.DoNotShowBlockUi)) {
			this.ResetBlockingState();
		}
	}

	/**
	 * Deals with an inconsistent counter/override state for http calls and a block override respectively.
	 * 	Generally used to correct interrupted infinite scrolls in the case of slow or non-existant connections. 
	 * 
	 * Method of intent. 
	 */
	private ResetBlockingState() {
		this._BlockUiService.DoNotShowBlockUi = false;
		this._BlockUiService.ClearCounter();
	}

}